"use client";

import { FilmstripRail } from "@demo/features/media/FilmstripRail";
import { useDisplayedMediaIndex, useMediaCarouselStore } from "@demo/store/media-carousel";

/**
 * Store-connected wrapper around the neutral {@link FilmstripRail}. The rail
 * itself takes no store, so it stays usable from any mode; this binds it to the
 * agent carousel for Compose.
 *
 * Renders nothing for a single asset — there is nothing to navigate between, and
 * the viewer takes the whole panel (its insets go to 0 to match).
 */
export const OutputFilmstrip = ({ orientation }: { orientation?: "vertical" | "horizontal" }) => {
  const media = useMediaCarouselStore((state) => state.mediaInAgentCarousel);
  const activeIndex = useDisplayedMediaIndex();
  const selectManually = useMediaCarouselStore((state) => state.selectMediaManually);

  if (media.length < 2) return null;

  return <FilmstripRail activeIndex={activeIndex} media={media} orientation={orientation} onSelect={selectManually} />;
};
